module.exports = __webpack_public_path__ + "img/login_user_icon.3cbd00c8.png";